<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" data-testid="directions-49" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Create Job Ad</ion-title>
    <ion-buttons slot="end">
      <ion-button data-testid="directions-50" @click="goNext()" :disabled="isSubmitDisabled">
        <span>Next</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <el-form class="full_page" :model="form" ref="userForm" label-position="top">

      <div class="button-wrapper">
        <el-button type="secondary" data-testid="directions-51" @click="setRateType('hourly')" :class="{ active: form.rate_type === 'hourly' }">
          Hourly
        </el-button>
        <el-button type="secondary" data-testid="directions-52" @click="setRateType('annual')" :class="{ active: form.rate_type === 'annual' }">
          Annual
        </el-button>
      </div>
      <div class="inner-label">
        {{ form.rate_type === 'hourly' ? 'Hourly' : 'Annual' }} Payment Range
        <span class="sub-label">(Excluding-super)</span>
      </div>
      <el-form-item :error="v$.min_rate.$error" :show-message="false" class="no-scroll" label="Min rate" :required="true"
        prop="min_rate">
        <div class="input-wrapper">
          <span class="el-input__prefix">
            $
          </span>
          <el-input data-testid="directions-53" v-model="form.min_rate" placeholder="0.00" @input="validateField('min_rate')"
            @keyup="checkValue('min_rate', $event)"></el-input>
        </div>
        <el-form-item-error v-if="v$.min_rate.$error">{{ v$.min_rate.$errors[0].$message }}</el-form-item-error>
      </el-form-item>
      <el-form-item :error="v$.max_rate.$error" :show-message="false" class="no-scroll" label="Max rate" :required="true"
        prop="max_rate">
        <div class="input-wrapper">
          <span class="el-input__prefix">
            $
          </span>
          <el-input data-testid="directions-54" v-model="form.max_rate" placeholder="0.00" @keyup="checkValue('max_rate', $event)"
            @input="validateField('max_rate')"></el-input>
        </div>
        <el-form-item-error v-if="v$.max_rate.$error">{{ v$.max_rate.$errors[0].$message }}</el-form-item-error>
      </el-form-item>

      <el-form-item :required="true" label="Are you willing to give bonus?" >
        <el-radio-group class="ml-4" v-model="form.bonus">
          <el-radio label="Yes" size="large">Yes</el-radio>
          <el-radio label="No" size="large">No</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- Button to submit the form -->
      <!-- <el-form-item class="button_submit mb0">
      <el-button class="submit" type="primary" :disabled="isSubmitDisabled" @click="handleSubmit">
        Continue <i class="el-icon-right"></i>
      </el-button>
    </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
import { reactive, computed, inject, onMounted } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import { IonToolbar, IonButton, IonButtons, IonIcon } from '@ionic/vue';
import { useRouter } from 'vue-router';
import { useStore } from "vuex";
// import { VueMaskDirective } from 'v-mask';

export default {

  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
  },

  setup() {
    const setPageClassGlobal = inject(['setPageClassGlobal']);
    const $router = useRouter();
    const $store = useStore();
    const jobListingCreatePageData = $store.getters.getJobListingCreatePageData;
    const form = reactive({
      min_rate: jobListingCreatePageData.min_rate ? jobListingCreatePageData.min_rate : null,
      max_rate: jobListingCreatePageData.max_rate ? jobListingCreatePageData.max_rate : null,
      rate_type: 'hourly', // Added rateType property
      bonus: 'No',
    });

    const pageText = {
      pageTitle: 'Your profile',
      formText: 'What are your salary expectations?',
    };

    const rules = computed(() => {
      return {
        min_rate: {
          required: helpers.withMessage('Please enter the valid min rate', required),
          numeric: helpers.withMessage('Rate must be a number', value => /^\d+(\.\d{1,2})?$/.test(value)),
          lessThanMax: helpers.withMessage('Min rate must be less than max rate', value => parseFloat(value) < parseFloat(form.max_rate))
        },
        max_rate: {
          required: helpers.withMessage('Please enter the valid max rate', required),
          numeric: helpers.withMessage('Rate must be a number', value => /^\d+(\.\d{1,2})?$/.test(value)),
          greaterThanMin: helpers.withMessage('Max rate must be greater than min rate', value => parseFloat(value) > parseFloat(form.min_rate))
        },
      };
    });

    const v$ = useVuelidate(rules, form);

    const isSubmitDisabled = computed(() => {
      return Object.values(form).some(value => value === null) || v$.value.$pending || v$.value.$error;
    });

    const setRateType = (type) => {
      form.rate_type = type;
      // validateField('rate'); // Trigger validation when rate type changes
    };

    const validateField = (fieldName) => {
      // Trigger validation for the specified field
      v$.value[fieldName].$touch();
    };

    const checkValue = (fieldName, event) => {
      const value = event.target.value;
      const regex = /^\d{0,8}(\.\d{0,2})?$/;
      if (!regex.test(value)) {
        // If the entered value doesn't match the format, remove the last character
        form[fieldName] = value.slice(0, -1);
      } else {
        // Update the field's value with the validated value
        form[fieldName] = value;
      }
    };
    
    const goNext = async () => {
      const result = await v$.value.$validate()

      if (!result) {
        alert('The form has errors')
        return
      } else {
        console.log("🚀 ~ goNext ~ result:", form)
        $store.dispatch("setJobListingCreatePageData", form);
        $router.push({
          name: 'job_description_listing',
        });
      }

    };

    // const handleSubmit = async () => {
    //   const result = await v$.value.$validate();
    //   console.log("🚀 ~ handleSubmit ~ result:", form)
    //   if (!result) {
    //     alert('The form has errors');
    //     return;
    //   }
    //   goNext();
    //   alert('Form submitted successfully');
    // };

    const goBack = () => {
      $router.push({
        name: 'job_create_listing'
      })
    };

    onMounted(() => {
      setPageClassGlobal('job_poster_create_job_rate');
      // validateField('rate');
    });

    return {
      form,
      pageText,
      v$,
      isSubmitDisabled,
      setRateType,
      validateField,
      goBack,
      goNext,
      checkValue,
    };
  }
};
</script>
